import { providerService } from '@/api'
// import active from './active'

const initialState = () => ({
  all: []
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    doneIds: state => state.all.filter(l => l.is_done),
    isDone: (state, getters) => listId => getters.doneIds.includes(listId)
  },
  actions: {
    async find({ commit, state, rootState }) {
      try {
        if (state.all.length) return state.all
        const result = await providerService.find({
          service: 'lists',
          query: {
            project_id: rootState.provider.projects.active.id
          }
        })
        commit('assign', result)
        return result
      } catch (err) {
        console.error(err)
      }
    }
  },
  mutations: {
    assign(state, data) {
      state.all = data
    }
  }
}
